module.exports = __webpack_public_path__ + "img/liangxin-top-bg.b51ca70c.png";